import Breadcrumb from '../components/Breadcrumb'
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from 'react';
import { maruzalar } from '../utils/Data';
import { Link } from 'react-router-dom';

function Maruza() {
    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: false,
        });
    }, []);
    return (
        <>
            <Breadcrumb text="Ma'ruzalar" />

            <section className="my-120 @">
                <div className="container-xl">
                    <div className="section-title center">
                        <div className="section-title-inner center w-v4">
                            <h4 className="sub-title" data-aos="fade-down" data-aos-duration="1000">Ma'ruza</h4>
                            <h2 className="big-title s-color-black" data-aos="fade-up" data-aos-duration="1000">
                                Barcha ma'ruza mashg'ulotlar
                            </h2>
                        </div>
                    </div>
                    <div className="row">
                        {
                            maruzalar.map(maruza => {
                                return <div
                                    key={maruza.id}
                                    className="col-xl-4 col-lg-4 col-md-6 col-sm-6"
                                    data-aos="fade-up"
                                    data-aos-duration="800"
                                    data-aos-delay="100"
                                >
                                    <div className="news-card">
                                        <div className="news-card-img">
                                            <Link to={`/maruza/${maruza.id}`}>
                                                <img src={maruza.image} alt={maruza.title} />
                                            </Link>
                                        </div>
                                        <div className="news-card-content">
                                            <div className="content-top">
                                                <div className="date"><div className="content-icon"><i className="fas fa-bookmark"></i></div>Ma'ruza</div>
                                            </div>
                                            <h4 className="title">
                                                <Link to={`/maruza/${maruza.id}`}>{maruza.title}</Link>
                                            </h4>
                                            <p className="para">
                                                {maruza.description.length > 110 ? maruza.description.slice(0, 110) + '...' : maruza.description}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            })
                        }
                    </div>
                </div>
            </section >
        </>
    )
}

export default Maruza